"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrAuthFormOverlay = void 0;
const react_1 = __importDefault(require("react"));
const fdr_auth_form_overlay_styles_1 = require("./fdr-auth-form-overlay.styles");
function FdrAuthFormOverlay({ title, text, children, }) {
    return (react_1.default.createElement(fdr_auth_form_overlay_styles_1.FdrAuthFormOverlayContent, null,
        title ? (react_1.default.createElement("h2", { className: "auth-form-title", "data-id": "auth-form-title" }, title)) : null,
        text && (react_1.default.createElement("div", { className: "auth-form-text", "data-id": "auth-form-text", dangerouslySetInnerHTML: { __html: text } })),
        children));
}
exports.FdrAuthFormOverlay = FdrAuthFormOverlay;
//# sourceMappingURL=fdr-auth-form-overlay.js.map